export const EXTENSION_FILTER_SELECTION_ALIGNMENT_TYPES = {
  ROW: 'ROW',
  COLUMN: 'COLUMN',
};

export const GET_EXTENSION_LIST_REQUEST =
  'Extensions/GET_EXTENSION_LIST_REQUEST';
export const GET_EXTENSION_LIST_SUCCESS =
  'Extensions/GET_EXTENSION_LIST_SUCCESS';
export const GET_EXTENSION_LIST_FAILURE =
  'Extensions/GET_EXTENSION_LIST_FAILURE';

export const GET_EXTENSION_VERTICAL_LIST_REQUEST =
  'Extensions/GET_EXTENSION_VERTICAL_LIST_REQUEST';
export const GET_EXTENSION_VERTICAL_LIST_SUCCESS =
  'Extensions/GET_EXTENSION_VERTICAL_LIST_SUCCESS';
export const GET_EXTENSION_VERTICAL_LIST_FAILURE =
  'Extensions/GET_EXTENSION_VERTICAL_LIST_FAILURE';

export const CREATE_EXTENSION_REQUEST = 
  'Extensions/CREATE_EXTENSION_REQUEST';
export const CREATE_EXTENSION_SUCCESS = 
  'Extensions/CREATE_EXTENSION_SUCCESS';
export const CREATE_EXTENSION_FAILURE = 
  'Extensions/CREATE_EXTENSION_FAILURE';
export const CREATE_EXTENSION_CLEAR =
  'Extensions/CREATE_EXTENSION_CLEAR';

export const GET_EXTENSION_DETAIL_REQUEST =
  'Extensions/GET_EXTENSION_DETAIL_REQUEST';
export const GET_EXTENSION_DETAIL_SUCCESS =
  'Extensions/GET_EXTENSION_DETAIL_SUCCESS';
export const GET_EXTENSION_DETAIL_FAILURE =
  'Extensions/GET_EXTENSION_DETAIL_FAILURE';

export const POST_ACTIVATE_EXTENSION_REQUEST =
  'Extensions/POST_ACTIVATE_EXTENSION_REQUEST';
export const POST_ACTIVATE_EXTENSION_SUCCESS =
  'Extensions/POST_ACTIVATE_EXTENSION_SUCCESS';
export const POST_ACTIVATE_EXTENSION_FAILURE =
  'Extensions/POST_ACTIVATE_EXTENSION_FAILURE';
export const POST_ACTIVATE_EXTENSION_RESET =
  'Extensions/POST_ACTIVATE_EXTENSION_RESET';

export const ADD_EXTENSION_CONFIG_OVERIDES_REQUEST =
  'Extensions/ADD_EXTENSION_CONFIG_OVERIDES_REQUEST';
export const ADD_EXTENSION_CONFIG_OVERIDES_SUCCESS =
  'Extensions/ADD_EXTENSION_CONFIG_OVERIDES_SUCCESS';
export const ADD_EXTENSION_CONFIG_OVERIDES_FAILURE =
  'Extensions/ADD_EXTENSION_CONFIG_OVERIDES_FAILURE';

export const PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_REQUEST =
  'Extensions/PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_REQUEST';
export const PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_SUCCESS =
  'Extensions/PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_SUCCESS';
export const PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_FAILURE =
  'Extensions/PROCESS_CONFIGURATION_API_BY_COMPONENT_TYPE_FAILURE';

export const GET_EXTENSION_VERSIONS_REQUEST = 
  'Extensions/GET_EXTENSION_VERSIONS_REQUEST';
export const GET_EXTENSION_VERSIONS_SUCCESS = 
  'Extensions/GET_EXTENSION_VERSIONS_SUCCESS';
export const GET_EXTENSION_VERSIONS_FAILURE = 
  'Extensions/GET_EXTENSION_VERSIONS_FAILURE';

export const PUBLISH_EXTENSION_VERSION_REQUEST = 
  'Extensions/PUBLISH_EXTENSION_VERSION_REQUEST';
export const PUBLISH_EXTENSION_VERSION_SUCCESS = 
  'Extensions/PUBLISH_EXTENSION_VERSION_SUCCESS';
export const PUBLISH_EXTENSION_VERSION_FAILURE = 
  'Extensions/PUBLISH_EXTENSION_VERSION_FAILURE';
export const PUBLISH_EXTENSION_VERSION_CLEAR = 
  'Extensions/PUBLISH_EXTENSION_VERSION_CLEAR';


export const POST_UPDATE_EXTENSION_VERSION_REQUEST =
  'Extensions/POST_UPDATE_EXTENSION_VERSION_REQUEST';
export const POST_UPDATE_EXTENSION_VERSION_SUCCESS =
  'Extensions/POST_UPDATE_EXTENSION_VERSION_SUCCESS';
export const POST_UPDATE_EXTENSION_VERSION_FAILURE =
  'Extensions/POST_UPDATE_EXTENSION_VERSION_FAILURE';

export const USER_ROLES = {
  ADMIN_USER: 'ADMIN_USER',
};

export const FILTER_UPDATE_TYPES = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
};

export const EXTENSTION_LIST_BY_KEYS = {
  WORKSWITH: 'worksWith',
  PROVIDER: 'provider',
  VERTICALS: 'verticals',
  STATUS: 'status',
  ACTIVE: 'active',
};

export const EXTENSION_LISTING_STATUS = {
  AVAILABLE: 'AVAILABLE',
  INSTALLED: 'INSTALLED',
};

export const EXTENSION_LISTING_ACTIVE = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const SEARCH_FILTER_ORDER_BY = {
  A_TO_Z_SORTING: 'A_TO_Z_SORTING',
  Z_TO_A_SORTING: 'Z_TO_A_SORTING',
  CREATED_DATE: 'CREATED_DATE',
  LAST_UPDATED_ON: 'LAST_UPDATED_ON',
};

export const EXTENSION_SORTBY_KEYS = {
  UPDATED_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
  NAME: 'name',
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const TOGGLE_STATUS = {
  ENABLED: 1,
  DISABLED: 0,
};

export const TOGGLELABLE_EXTENSION_LISTING_FILTERS = ['status', 'active'];

export const EXTENSION_VIEW_TABS = {
  OVERVIEW: 'OVERVIEW',
  CONFIGURE: 'CONFIGURE',
};

export const EXTENSION_FORMULA_NAME_ENUMS = {
  AIRMILES_FORMULA: 'AirmilesFormula',
};

export const EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES = {
  INPUT_FIELD_COMPONENT: 'INPUT_FIELD_COMPONENT',
  UPLOAD_COMPONENT: 'UPLOAD_COMPONENT',
  DOWNLOAD_COMPONENT: 'DOWNLOAD_COMPONENT',
  DROPDOWN_COMPONENT: 'DROPDOWN_COMPONENT',
  RADIO_CHECKBOX_COMPONENT: 'RADIO_CHECKBOX_COMPONENT',
  MULTIPLE_RADIO_CHECKBOX_COMPONENT: 'MULTIPLE_RADIO_CHECKBOX_COMPONENT',
  INPUT_TEXTDATA_FIELD_COMPONENT: 'INPUT_TEXTDATA_FIELD_COMPONENT',
  TOGGLE_BUTTON_COMPONENT: 'TOGGLE_BUTTON_COMPONENT',
  READONLY_TEXTBOX_COMPONENT: 'READONLY_TEXTBOX_COMPONENT',
};

export const EXTENSION_CONFIGURATION_NON_UPDATABLE_CONFIG_COMPONENTS = [
  EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES.DOWNLOAD_COMPONENT,
  EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES.CSV_UPLOAD,
  EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES.READONLY_TEXTBOX_COMPONENT,
];

export const EXTENSION_CONFIGURATION_NON_UNIQUE_CHECK_CONFIG_COMPONENTS = [
  EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES.DOWNLOAD_COMPONENT,
  EXTENSION_CONFIGURATION_COMPONENT_RENDER_TYPES.CSV_UPLOAD,
];

export const EXTENSION_LINKS = {
  KNOW_MORE_LINK: 'https://docs.capillarytech.com/docs/extension',
};

export const EXTENSION_MAX_POSSIBLE_VALUES = 3;

export const EXTENSION_ENABLE_MODES = {
  LIVE: 'live',
  PREVIEW: 'preview',
  UAT: 'uat',
};

export const GET_ORG_HIERARCHY_REQUEST =
  'Extensions/GET_ORG_HIERARCHY_REQUEST';
export const GET_ORG_HIERARCHY_SUCCESS =
  'Extensions/GET_ORG_HIERARCHY_SUCCESS';
export const GET_ORG_HIERARCHY_FAILURE =
  'Extensions/GET_ORG_HIERARCHY_FAILURE';
